// Profile «Почта» and Подключения: what the mailbox form sends to crm-api.

export const MAIL_SETTINGS_KEY = ["vv-mail-settings"];

export type MailboxFormValues = {
  from_addr: string;
  from_name: string;
  smtp_host: string;
  smtp_port: string;
  imap_host: string;
  imap_port: string;
  login: string;
  password: string;
};
export const EMPTY_MAILBOX: MailboxFormValues = {
  from_addr: "",
  from_name: "",
  smtp_host: "",
  smtp_port: "",
  imap_host: "",
  imap_port: "",
  login: "",
  password: "",
};

/** what the API gets: one login and one password for both SMTP and IMAP */
export const mailboxFields = (
  form: MailboxFormValues,
  keys: string[],
): Record<string, string> => {
  const out: Record<string, string> = {};
  for (const k of [
    "from_addr",
    "from_name",
    "smtp_host",
    "smtp_port",
    "imap_host",
    "imap_port",
  ] as const) {
    if (form[k].trim()) out[k] = form[k].trim();
  }
  const login =
    form.login.trim() ||
    (!keys.includes("smtp_user") && form.from_addr.trim()) ||
    "";
  if (login) {
    out.smtp_user = login;
    out.imap_user = login;
  }
  if (form.password) {
    out.smtp_password = form.password;
    out.imap_password = form.password;
  }
  return out;
};
